import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { StockCountByQISummaryDailyReportCriteria } from '@shared/models/report.model';
import { BaseService } from '@shared/services/base.service';

import { StockCountByQIDailySummary } from '../model/stock-count-report.model';

@Injectable({
  providedIn: 'root'
})
export class StockCountReportService extends BaseService {
  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.stockCountReport;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getStockCountByQIDailySummary(
    request: StockCountByQISummaryDailyReportCriteria
  ): Observable<StockCountByQIDailySummary> {
    const url = this.getFullUrl(this.envService.stockCountByQIDailySummary);
    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(0),
      observe: 'body'
    });
  }
}
